import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";

import "../src/design/app.scss";

import store from "@/state/store";

import App from "./App.vue";

import { initFirebaseBackend } from "./authUtils";
import i18n from "./i18n";

import { configureFakeBackend } from "./helpers/fake-backend";

import tinymce from "vue-tinymce-editor";

// Capa responsive empresarial reutilizable (Fase 0) - solo presentación
import ResponsiveKit from "@/components/responsive";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    // La URL del backend GraphQL se define en build-time via VUE_APP_URL_GRAPH
    // (sin barra final). Antes estaba hardcodeada a un dominio viejo.
    uri: process.env.VUE_APP_URL_GRAPH + "/graphql",
  }),
});

Vue.use(VueApollo);

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.component("tinymce", tinymce);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("apexchart", VueApexCharts);
Vue.use(ResponsiveKit);
// console.log(process.env.VUE_APP_URL_GRAPH);

new Vue({
  router,
  apolloProvider,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
